export default "__VITE_ASSET__Rq_wFIll__"